// @ts-nocheck
/**
 * @deprecated Use readImageFileSeries from @itk-wasm/image-io instead
 */
async function readImageFileSeries(fileList, options, zOriginBackwardsCompatibility, sortedSeriesBackwardsCompatibility) {
    throw new Error('readImageFileSeries is deprecated. Use readImageFileSeries from @itk-wasm/image-io instead.');
}
export default readImageFileSeries;
//# sourceMappingURL=read-image-file-series.js.map